<template>
<inertia-head title="Affiliate Contest" />
<div class="bg-trc-main">
	<div class="bg-black-25">
		<div class="content text-center">
			<div class="py-0 mb-3">
				<h1 class="fw-bold text-white mb-2">
				Affiliate Introduction
				</h1>
				<h2 class="h4 fw-normal text-white-75 fs-sm">How to use the TRC affiliate system.</h2>
			</div>
		</div>
	</div>
</div>
<div class="content">
	<div class="row">
		<div class="block block-rounded">
			<div class="block-content block-content-full">
				<div style="padding: 56.25% 0 0 0; position: relative">
					<iframe
					:src="'https://player.vimeo.com/video/'+$page.props.aff_intro_vimeo_id"
					style="
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					"
					frameborder="0"
					allow="autoplay; fullscreen; picture-in-picture"
					allowfullscreen
					></iframe>
				</div>
			</div>
		</div>
	</div>
	<div class="row mt-3">
		<div class="block block-rounded">
			<div class="block-header border-bottom">
				<h4 class="h4 m-0"><i class="fa fa-video"></i> How to do affiliate marketing</h4>
			</div>
			<div class="block-content block-content-full">
				<div class="container">
					<div class="row">
						<!-- 1 -->
						<div class="col-md-6 mt-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
								src="https://player.vimeo.com/video/352385732"
								style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								></iframe>
							</div>
							<h5 class="mt-3">Module 1 - How I Earned Millions of Pesos Online (My Story)</h5>
						</div>
						<!-- 2 -->
						<div class="col-md-6 mt-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
								src="https://player.vimeo.com/video/352386932"
								style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								></iframe>
							</div>
							<h5 class="mt-3">Module 2 - Earn Online with TRC Affiliate System</h5>
						</div>
						<!-- 3 -->
						<div class="col-md-6 mt-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
								src="https://player.vimeo.com/video/352386970"
								style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								></iframe>
							</div>
							<h5 class="mt-3">Module 3 - How to do Affiliate Marketing and Earn</h5>
						</div>
						<!-- 4 -->
						<div class="col-md-6 mt-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
								src="https://player.vimeo.com/video/352387033"
								style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								></iframe>
							</div>
							<h5 class="mt-3">Module 4 - Your Six Steps to Your First 100k</h5>
						</div>
						<!-- 5 -->
						<div class="col-md-6 mt-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
								src="https://player.vimeo.com/video/352387063"
								style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								></iframe>
							</div>
							<h5 class="mt-3">Module 5 - Top Mistakes and Myths of an Affiliate</h5>
						</div>
						<!-- 6 -->
						<div class="col-md-6 mt-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
								src="https://player.vimeo.com/video/352387105"
								style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								></iframe>
							</div>
							<h5 class="mt-3">Module 6 - 14 Strategies and 12 Tips to be the Best Affiliate Marketer</h5>
						</div>
						<!-- 7 -->
						<div class="col-md-6 mt-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
								src="https://player.vimeo.com/video/352385740"
								style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								></iframe>
							</div>
							<h5 class="mt-3">Module 7 - 12 Must Have Marketing Mindsets</h5>
						</div>
						<!-- 8 -->
						<div class="col-md-6 mt-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
								src="https://player.vimeo.com/video/352387162"
								style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								></iframe>
							</div>
							<h5 class="mt-3">Module 8 - Promoting Product Online</h5>
						</div>
						<!-- 9 -->
						<div class="col-md-6 mt-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
								src="https://player.vimeo.com/video/352387167"
								style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								></iframe>
							</div>
							<h5 class="mt-3">Module 9 - Email Marketing Basic</h5>
						</div>
						<!-- 10 -->
						<div class="col-md-6 mt-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
								src="https://player.vimeo.com/video/352385752"
								style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								></iframe>
							</div>
							<h5 class="mt-3">Module 10 - Email Marketing Advance</h5>
						</div>
						<!-- 11 -->
						<div class="col-md-6 mt-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
								src="https://player.vimeo.com/video/352385758"
								style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								></iframe>
							</div>
							<h5 class="mt-3">Module 11 - Blogging or Vlogging</h5>
						</div>
						<!-- 12 -->
						<div class="col-md-6 mt-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
								src="https://player.vimeo.com/video/352385764"
								style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								></iframe>
							</div>
							<h5 class="mt-3">Module 12 - Facebook Marketing</h5>
						</div>
						<!-- 13 -->
						<div class="col-md-6 mt-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
								src="https://player.vimeo.com/video/352385767"
								style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
								></iframe>
							</div>
							<h5 class="mt-3">Module 13 - Webinar Marketing</h5>
						</div>
						
						
						
						
					</div>
				</div>
			</div>
		</div>
	</div>
	
	<div class="row mt-3">
		<div class="block block-rounded">
			<div class="block-header border-bottom">
				<h4 class="h4 m-0"><i class="fa fa-video"></i> OTHER TRAINING VIDEOS</h4>
			</div>
			<div class="block-content block-content-full">
				<div class="container">
					<div class="row">
				
				<div class="col-md-6 mt-2">
					<div style="padding: 56.25% 0 0 0; position: relative">
						<iframe
						src="https://player.vimeo.com/video/603660542"
						style="
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						"
						frameborder="0"
						allow="autoplay; fullscreen; picture-in-picture"
						allowfullscreen
						></iframe>
					</div>
				</div>
				<div class="col-md-6 mt-2">
					<div style="padding: 56.25% 0 0 0; position: relative">
						<iframe
						src="https://player.vimeo.com/video/858863666"
						style="
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						"
						frameborder="0"
						allow="autoplay; fullscreen; picture-in-picture"
						allowfullscreen
						></iframe>
					</div>
				</div>
				</div>
				</div>

				
				
			</div>
		</div>
	</div>
</div>
</template>
<script>
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', window.gtag_id);
	
import { watch, onMounted } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import { createToaster } from '@meforma/vue-toaster'
import { useForm } from '@inertiajs/inertia-vue3'
export default {
	props:{
		flash 				: Object,
		affContest 			: Object,
		affContestList 		: Object,
		topTenAff 			: Object,
	},
	layout: AuthLayout,
	setup(props) {
		const toast = createToaster();
		
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
			{
				pageContainer.classList.remove('sidebar-o-xs')
			}
			
		})
		return{
			
		}
	},
}
</script>